import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useLang } from "@/context/LanguageContext";
import { SectionHeading } from "@/components/SectionHeading";
import { VideoCard } from "@/components/VideoCard";

export const Politics = () => {
  const { t } = useLang();
  const [active, setActive] = useState("all");
  const filtered = active === "all" ? t.politics.items : t.politics.items.filter((i) => i.category === active);

  return (
    <section id="politics" data-testid="politics-section" className="bg-ink py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <SectionHeading
          eyebrow={t.politics.eyebrow}
          title={t.politics.title}
          titleItalic={t.politics.titleItalic}
          description={t.politics.description}
        />

        <div className="mt-10 flex flex-wrap gap-3" role="tablist" aria-label={t.politics.eyebrow}>
          {t.politics.filters.map((f) => (
            <button
              key={f.id}
              type="button"
              role="tab"
              aria-selected={active === f.id}
              onClick={() => setActive(f.id)}
              data-testid={`politics-filter-${f.id}`}
              className={`rounded-full border px-5 py-2 text-xs font-semibold uppercase tracking-wider transition-colors duration-300 ${
                active === f.id
                  ? "border-ember bg-ember text-ink"
                  : "border-line text-ash hover:border-ember/60 hover:text-cream"
              }`}
            >
              {f.label}
            </button>
          ))}
        </div>

        <motion.div layout className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-testid="politics-grid">
          <AnimatePresence mode="popLayout">
            {filtered.map((item, i) => (
              <motion.div
                layout
                key={item.title}
                initial={{ opacity: 0, y: 24 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, scale: 0.96 }}
                transition={{ duration: 0.45, delay: i * 0.04, ease: [0.22, 1, 0.36, 1] }}
              >
                <VideoCard
                  item={{ ...item, category: t.politics.filterLabels[item.category] || item.category }}
                  testId={`politics-card-${i}`}
                />
              </motion.div>
            ))}
          </AnimatePresence>
        </motion.div>
      </div>
    </section>
  );
};
